import { Label } from "@/components/ui/label";

interface ScoreSliderProps {
  id: string;
  label: string;
  description?: string;
  value: number;
  onChange: (val: number) => void;
}

/** Tablet-friendly slider 0-100 se velkými kroky + popisky stavu. */
export function ScoreSlider({ id, label, description, value, onChange }: ScoreSliderProps) {
  return (
    <div className="space-y-3" data-testid={`hca-diagnoza-slider-${id}`}>
      <Label htmlFor={id} className="text-xl font-semibold">
        {label}
      </Label>
      {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}

      <div className="flex items-center justify-between text-[0.7rem] uppercase tracking-wider text-muted-foreground">
        <span>Slabě</span>
        <span
          className="text-2xl font-semibold tabular-nums text-foreground"
          data-testid={`hca-diagnoza-slider-${id}-value`}
        >
          {value}
        </span>
        <span>Velmi dobře</span>
      </div>

      <input
        id={id}
        type="range"
        min={0}
        max={100}
        step={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="h-3 w-full cursor-pointer appearance-none rounded-full bg-muted accent-primary"
        data-testid={`hca-diagnoza-slider-${id}-input`}
      />

      <div className="grid grid-cols-5 gap-1 text-center text-[0.65rem] text-muted-foreground">
        <span>0</span>
        <span>25</span>
        <span>50</span>
        <span>75</span>
        <span>100</span>
      </div>
    </div>
  );
}
